// Search-panel schema for the IM Item Management "Item/Lot" tab. Field names match the load params the
// GetItemLots endpoint expects (see GetItemLotMainStore). First 8 fields are visible (4 groups of 2); the
// rest ride along hidden (visible:false) via the form's field chooser.
const f = (name, label, type, visible, options) => ({
  name, tableName: "", label, type, options: options || null, apiUrl: null, grid: null, required: false, visible,
});

const codes = (prefix, labelScope, from, to) => {
  const out = [];
  for (let i = from; i <= to; i++) out.push(f(`${prefix}${i}`, `Code ${i} - ${labelScope}`, "text", false));
  return out;
};

const ItemLotFormLayout = [
  {
    groupId: 1,
    label: "",
    fields: [
      f("ItemCode", "Item", "text", true),
      f("LotCode", "Lot", "text", true),
      ...codes("ItemCode", "Item", 1, 3),
    ],
  },
  {
    groupId: 2,
    label: "",
    fields: [
      f("ItemDescription1", "Item Description - 1", "text", true),
      f("LotDescription1", "Lot Description - 1", "text", true),
      ...codes("ItemCode", "Item", 4, 7),
    ],
  },
  {
    groupId: 3,
    label: "",
    fields: [
      f("ItemClassCode", "Item Class", "text", true),
      f("LotClassCode", "Lot Class", "text", true),
      f("ItemSubClassCode", "Item Subclass", "text", false),
      f("LotSubClassCode", "Lot Subclass", "text", false),
      ...codes("ItemCode", "Item", 8, 10),
    ],
  },
  {
    groupId: 4,
    label: "",
    fields: [
      // Lot Status is a descriptive dropdown (options injected in onFormLoad).
      f("LotStatus", "Lot Status", "select", true),
      f("Warehouse", "WH-Item", "text", true),
      ...codes("LotCode", "Lot", 1, 10),
    ],
  },
];

export default ItemLotFormLayout;
